import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e992fe8a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "b-step1-detail-wrapper" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "bank-name" }, "开户行名称", -1))
const _hoisted_3 = { class: "item" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "title" }, "开户行名称：", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "bank-name",
  style: {"margin-top":"28px"}
}, "开户所需集团资料申请", -1))
const _hoisted_6 = { class: "item" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "title" }, "公司主体名称：", -1))
const _hoisted_8 = { style: {"color":"#333"} }

import {
  ref,
  onMounted,
  withDefaults,
  computed,
  watch,
} from "vue";
import { getBankAccountApply } from "@/api/process_bank";
import { PLAINOPTIONS } from "@/const/home";

export default /*#__PURE__*/_defineComponent({
  props: {
    detail: { default: () => {
      return {
        PageData: {
          YhDocumentCollection: "",
          YhBankName: "",
          YhCompanyEntity: "",
        },
        update: false,
        folwId: 0,
      };
    } },
    update: { type: Boolean },
    folwId: null
  },
  emits: ["change-status"],
  setup(__props: any, { emit: $emit }) {

const props = __props as { detail: {
      PageData?: {
        YhDocumentCollection?: string;
        YhBankName?: string;
        YhCompanyEntity?: string;
      };
    }, update: boolean, folwId: number }




return (_ctx: any,_cache: any) => {
  const _component_a_checkbox = _resolveComponent("a-checkbox")!
  const _component_a_checkbox_group = _resolveComponent("a-checkbox-group")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("p", _hoisted_3, [
      _hoisted_4,
      _createTextVNode(_toDisplayString(__props.detail.PageData && __props.detail.PageData.YhBankName), 1)
    ]),
    (__props.detail.PageData && __props.detail.PageData.YhCompanyEntity)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _hoisted_5,
          _createElementVNode("p", _hoisted_6, [
            _hoisted_7,
            _createTextVNode(_toDisplayString(__props.detail.PageData && __props.detail.PageData.YhCompanyEntity), 1)
          ]),
          _createVNode(_component_a_checkbox_group, {
            disabled: "",
            value: __props.detail.PageData && __props.detail.PageData.YhDocumentCollection
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.detail.PageData &&
          __props.detail.PageData.YhDocumentCollection, (item, index) => {
                return (_openBlock(), _createBlock(_component_a_checkbox, {
                  key: index,
                  class: _normalizeClass(index == 9 ? 'nomargin' : ''),
                  value: item.toString()
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", _hoisted_8, _toDisplayString(_unref(PLAINOPTIONS)[item - 1]), 1)
                  ]),
                  _: 2
                }, 1032, ["class", "value"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["value"])
        ], 64))
      : _createCommentVNode("", true)
  ]))
}
}

})